/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unprocessable entity
 * @export
 * @interface GetKillmailsKillmailIdKillmailHashUnprocessableEntity
 */
export interface GetKillmailsKillmailIdKillmailHashUnprocessableEntity {
    /**
     * Unprocessable entity message
     * @type {string}
     * @memberof GetKillmailsKillmailIdKillmailHashUnprocessableEntity
     */
    error?: string;
}

/**
 * Check if a given object implements the GetKillmailsKillmailIdKillmailHashUnprocessableEntity interface.
 */
export function instanceOfGetKillmailsKillmailIdKillmailHashUnprocessableEntity(value: object): value is GetKillmailsKillmailIdKillmailHashUnprocessableEntity {
    return true;
}

export function GetKillmailsKillmailIdKillmailHashUnprocessableEntityFromJSON(json: any): GetKillmailsKillmailIdKillmailHashUnprocessableEntity {
    return GetKillmailsKillmailIdKillmailHashUnprocessableEntityFromJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashUnprocessableEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKillmailsKillmailIdKillmailHashUnprocessableEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetKillmailsKillmailIdKillmailHashUnprocessableEntityToJSON(json: any): GetKillmailsKillmailIdKillmailHashUnprocessableEntity {
    return GetKillmailsKillmailIdKillmailHashUnprocessableEntityToJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashUnprocessableEntityToJSONTyped(value?: GetKillmailsKillmailIdKillmailHashUnprocessableEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

